// ============================================================================
// STATUS MESSAGES COMPONENT
// ============================================================================

import React from "react";
import { Alert } from "@mui/material";
import { OrderCreationState } from "../types";

interface StatusMessagesProps {
  orderCreationState: OrderCreationState;
}

const StatusMessages: React.FC<StatusMessagesProps> = ({ orderCreationState }) => {
  if (orderCreationState.error) {
    return (
      <Alert severity="error" sx={{ m: 2 }}>
        {orderCreationState.error}
      </Alert>
    );
  }

  if (orderCreationState.success) {
    return (
      <Alert severity="success" sx={{ m: 2 }}>
        Order created successfully!
      </Alert>
    );
  }

  return null;
};

export default StatusMessages;
